import React, { useState } from "react";
import { NavLink, withRouter } from "react-router-dom";
import style from "./SideNav.module.scss";
import StratusLogo from "../../../images/v2/stratus_logo.png";
import CaretDown from "../assets/svg/icons/common/CaretDown";
import Files from "../assets/svg/icons/common/Files";
import Home from "../assets/svg/icons/common/Home";
import Building from "../assets/svg/icons/common/Building";
import Store from "../assets/svg/icons/common/Store";
import JoyStick from "../assets/svg/icons/common/JoyStick";
import SuitcaseIcon from "../assets/svg/icons/common/SuitcaseIcon";
import CaretLeft from "../assets/svg/icons/common/CaretLeft";
import PCLogoFull from "../assets/svg/icons/common/PCLogoFull";
import PCLogoIcon from "../assets/svg/icons/common/PCLogoIcon";
import useCommonStore from "../stores/common";
import useUserStore from "../stores/user";
import ReactTooltip from "react-tooltip";

const SideNav = ({ location }) => {
  const user = useUserStore((state) => state.user);
  const isViewResiduals = useUserStore((state) => state.isViewResiduals);
  const isAgent = useUserStore((state) => state.isAgent);
  const isPCAdmin = useUserStore((state) => state.isPCAdmin);
  const isAdmin = useUserStore((state) => state.isAdmin);
  const sideNavCollapsed = useCommonStore((state) => state.sideNavCollapsed);
  const setSideNavCollapsed = useCommonStore(
    (state) => state.setSideNavCollapsed,
  );
  const [expandedMenus, setExpandedMenus] = useState({});

  const setNavCollapsing = (value) => {
    if (value) {
      setSideNavCollapsed(true);
      setExpandedMenus({});
    } else {
      setSideNavCollapsed(false);
    }
  };

  const toggleMenu = (menu) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  const links = [
    // {
    //   name: "Overview",
    //   route: "dashboard",
    //   icon: <Home />,
    // },
    {
      name: "Applications",
      route: "applications",
      icon: <Files />,
      show: true,
    },
    {
      name: "Organizations",
      route: "organizations",
      icon: <Building />,
      show: (isAgent && isViewResiduals) || isAdmin || isPCAdmin,
    },
    {
      name: "Merchants",
      route: "merchants",
      icon: <Store />,
      show: true,
    },
    {
      name: "System",
      route: "transactions",
      icon: <JoyStick />,
      hasChild: true,
      show: isPCAdmin,
      childLinks: [
        {
          name: "MCC Codes",
          route: "mcc",
          show: isPCAdmin,
        },
        {
          name: "Processors",
          route: "processors",
          show: isPCAdmin,
        },
      ],
    },
    {
      name: "Tools",
      route: "transactions",
      icon: <SuitcaseIcon />,
      hasChild: true,
      show: isPCAdmin,
      childLinks: [
        {
          name: "Templates",
          route: "templates",
          show: isPCAdmin,
        },
      ],
    },
  ];

  return (
    <nav
      className={`${style.side_nav} ${sideNavCollapsed ? style.collapsed : ""}`}
    >
      <div className={style.side_nav_header}>
        {!sideNavCollapsed ? (
          <span>
            <PCLogoFull />
          </span>
        ) : (
          <span>
            <PCLogoIcon />
          </span>
        )}

        <button onClick={() => setNavCollapsing(!sideNavCollapsed)}>
          <CaretLeft />
        </button>
      </div>

      <ul
        className={`${style.nav_list} ${sideNavCollapsed ? style.collapsed : ""}}`}
      >
        {links
          .filter((link) => link?.show ?? true)
          .map((link, index) => (
            link.show && (
              <li
                key={index}
                className={
                  location.pathname === `${user?.is_v2_enable == 1 ? '' : '/v2'}/${link.route}` ||
                    (link.hasChild &&
                      link.childLinks.some(
                        (childLink) =>
                          location.pathname === `${user?.is_v2_enable == 1 ? '' : '/v2'}/${childLink.route}`,
                      ))
                    ? style.active_item
                    : ""
                }
                data-for={link.route}
                data-tip
              >
                {!link.hasChild && (
                  <ReactTooltip
                    id={link.route}
                    aria-haspopup="true"
                    place="right"
                    type="dark"
                    effect="solid"
                  >
                    <p>{link.name}</p>
                  </ReactTooltip>
                )}
                <NavLink
                  to={link.hasChild ? "#" : `${user?.is_v2_enable == 1 ? '' : '/v2'}/${link.route}`}
                  onClick={() => {
                    if (link.hasChild) {
                      toggleMenu(link.name);
                    }
                  }}
                >
                  <span className="icon">{link.icon}</span>
                  <span className={`${style.nav_text} nav-text`}>
                    {link.name}
                  </span>
                  {link.hasChild && !sideNavCollapsed && (
                    <span>
                      <CaretDown />
                    </span>
                  )}
                </NavLink>

                {/* child links */}
                {link.hasChild && expandedMenus[link.name] && (
                  <ul className={style.child_links}>
                    {link.childLinks.filter((childLink) => childLink?.show ?? true).map((childLink, index) => (
                      <li
                        key={index}
                        className={
                          location.pathname === `${user?.is_v2_enable == 1 ? '' : '/v2'}/${childLink.route}`
                            ? style.child_active_item
                            : ""
                        }
                        data-for={childLink.route}
                        data-tip
                      >
                        <NavLink to={`${user?.is_v2_enable == 1 ? '' : '/v2'}/${childLink.route}`}>
                          <span className={style.child_link_icon}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="6"
                              height="6"
                              viewBox="0 0 6 6"
                              fill="none"
                            >
                              <circle cx="3" cy="3" r="3" fill="white" />
                            </svg>
                          </span>
                          <span className={`${style.child_link_text} nav-text`}>
                            {childLink.name}
                          </span>
                        </NavLink>
                        <ReactTooltip
                          id={childLink.route}
                          aria-haspopup="true"
                          place="right"
                          type="dark"
                          effect="solid"
                        >
                          <p>{childLink.name}</p>
                        </ReactTooltip>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            )
          ))}
      </ul>
      <div className={style.side_nav_footer}>
        <div>
          <span>Powered by</span>
          <img src={StratusLogo} alt="Stratus Logo" />
        </div>
      </div>
    </nav>
  );
};

export default withRouter(SideNav);
